module.exports = __webpack_public_path__ + "static/media/covid_ro_ceicareneoferajutor.55543351.svg";